import React, { useContext, useState } from 'react'
import Uploader from '../Components/Uploader/Uploader'
import UploadFormFill from '../Components/UploadFormFill/UploadFormFill'
import UploadHome from '../Components/UploadHome/UploadHome'
import Context from '../context/Context'

function UploadPageNew() {
    const [participate, setParticipate] = useState(true)
    const [uploading, setUploading] = useState(false)
    const [details, setdetails] = useState(false)
    const { data } = useContext(Context)
    if (participate) {
        return (
            <div>
                <UploadHome setParticipate={setParticipate} setUploading={setUploading} />
            </div>
        )
    } else if (uploading) {
        return (
            <div>
                <Uploader setUploading={setUploading} setdetails={setdetails} />
            </div>
        )
    } else {
        return (
            <div>
                <UploadFormFill setParticipate={setParticipate} setUploading={setUploading} setdetails={setdetails}/>
            </div>
        )
    }

}

export default UploadPageNew